export const getStarterUrl = '/get-started/';
export const buildYourGrowthPlanUrl = '/Build-your-growth-plan/';
export const onboardingUrl = '/onboarding/';
export const accountUrl = '/account';
